// extracted by mini-css-extract-plugin
export default {"base":"Toggle_base__apHby","dot":"Toggle_dot__01v2w","active":"Toggle_active__GaRvE"};